/**
 * @generated SignedSource<<64be893856e1c42e03a4f6def4eb29cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoBottomSheetTitle_todo$data = {
  readonly canWrite: boolean;
  readonly id: string;
  readonly taskExecution: {
    readonly task: {
      readonly issueSuggestions: ReadonlyArray<{
        readonly title: string;
      }>;
    };
  } | null;
  readonly title: string;
  readonly " $fragmentType": "TodoBottomSheetTitle_todo";
};
export type TodoBottomSheetTitle_todo$key = {
  readonly " $data"?: TodoBottomSheetTitle_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoBottomSheetTitle_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoBottomSheetTitle_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "taskExecution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "task",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueSuggestion",
              "kind": "LinkedField",
              "name": "issueSuggestions",
              "plural": true,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "1be4f04235e77e3a0dac028a1f687de6";

export default node;
